export default __webpack_public_path__ + "static/media/assemble9.69f88351.png";